import { LogError } from './logging/LogError';

const MAX_POLLING_COUNT = 20;
const POLLING_INTERVAL_MS = 3000;

export function getPollingHelper({
  transactionId,
  resultsRequest,
  shouldPollFunc,
  maxPollingCount = MAX_POLLING_COUNT,
  pollingIntervalMs = POLLING_INTERVAL_MS,
}) {
  let resultsCallCount = 0;
  let pollingFailures = 0;
  let _shouldPollFunc = shouldPollFunc;
  let _transactionId = transactionId;
  let _resultsRequest = resultsRequest;
  let latestResultsResponse = null;

  function pollResults(shouldPoll = true, isInitialPoll = false) {
    if (!_transactionId) {
      throw new Error('transactionId is required');
    } else if (!_resultsRequest) {
      throw new Error('resultsRequest is required');
    } else if (!_shouldPollFunc) {
      throw new Error('shouldPollFunc is required');
    }

    if (!shouldPoll) {
      return Promise.resolve(false);
    }
    return new Promise((resolve) => {
      setTimeout(
        async () => {
          resultsCallCount += 1;
          const resultsResponse = await _resultsRequest({
            transactionId: _transactionId,
          }).catch((error) => {
            pollingFailures += 1;
            if (pollingFailures > 3) {
              LogError('Polling transaction failed', { error: error?.message });
            }
          });
          latestResultsResponse = resultsResponse;
          resolve(
            await pollResults(
              _shouldPollFunc(resultsResponse) &&
                resultsCallCount < maxPollingCount
            )
          );
        },
        isInitialPoll ? 0 : pollingIntervalMs
      );
    });
  }

  return {
    startPolling: async () => {
      if (!_transactionId) {
        LogError('No transaction Id was returned from submit request');
      }
      await pollResults(
        /* should poll */ Boolean(_transactionId),
        /* isInitialPoll */ false
      );
      return latestResultsResponse;
    },
    setShouldPoll: (shouldPollFuncReplacement) => {
      _shouldPollFunc = shouldPollFuncReplacement;
    },
    setTransactionId: (transactionIdReplacement) => {
      _transactionId = transactionIdReplacement;
    },
    setResultsRequest: (resultsRequestReplacement) => {
      _resultsRequest = resultsRequestReplacement;
    },
    getTransactionId: () => {
      return _transactionId;
    },
  };
}
